export default "__VITE_ASSET__BaHCrGaF__"